__turbopack_context__.v({
  "cta": "FansLeaderboardEmptyState-module-scss-module__pHp2xq__cta",
  "illustration": "FansLeaderboardEmptyState-module-scss-module__pHp2xq__illustration",
  "root": "FansLeaderboardEmptyState-module-scss-module__pHp2xq__root",
  "subtitle": "FansLeaderboardEmptyState-module-scss-module__pHp2xq__subtitle",
  "text": "FansLeaderboardEmptyState-module-scss-module__pHp2xq__text",
  "title": "FansLeaderboardEmptyState-module-scss-module__pHp2xq__title",
});
